// test621
(621 && 0);
